import useRepo from '@/nebula/repo';
import {
  propertyOption as propertyOptionConfig,
} from 'shared/api/query/configs.json';
import { useStore } from 'vuex';

export default function usePropertyOptionsRepo() {
  const model = propertyOptionConfig.model;
  const repo = useRepo(model);
  const store = useStore();

  const updateSingle = (entity) => repo.updateSingle(entity).then((data) => {
    store.commit('PROPERTY_OPTION_UPDATED', { entity: repo.selectSingle(data.uid) });
    return repo.selectSingle(data.uid);
  });

  const deleteSingle = (entity) => deleteMultiple([entity]);

  const deleteMultiple = (entities) => {
    store.commit('PROPERTY_OPTIONS_DELETED', { entities });
    return repo.deleteMultiple(entities.map((e) => e.uid));
  };

  return {
    createSingle: repo.createSingle,
    updateSingle,
    deleteSingle,

    createLoading: repo.createLoading,
    createMultiple: repo.createMultiple,

    deleteLoading: repo.deleteLoading,
    deleteMultiple,

    propertyOptions: repo.entityList,
    selectSingle: repo.selectSingle,
    selectMultiple: repo.selectMultiple,

    getList: repo.getList,
  };
}
